import styled from 'styled-components';

export const Container = styled.div`
  margin-block-start: 20px;
  margin-inline-start: 16px;
`;
